import * as React from 'react';
import { Button, Col, Form, Modal, ModalProps, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { AppVersionConfig } from '../../../../../../__gqltypes__';

type Props = {
  loading: boolean;
  config: AppVersionConfig | null;
  onSave: (forceUpdateType: string) => void;
} & ModalProps;

const EditVersionConfigModal = ({ show, onHide, onSave, loading, config }: Props) => {
  const [forceUpdateType, setForceUpdateType] = React.useState('optional');

  React.useEffect(() => {
    if (config?.forceUpdateType) {
      setForceUpdateType(config.forceUpdateType);
    }
  }, [config]);

  if (!config) {
    return null;
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-pen mr-2" />
          Edit NVS Campaign
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mt-2">
          <Col xs={3}>
            <span>Version</span>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="nvs-version-tooltip">This is the NVS target version.</Tooltip>}
            >
              <i className="fas fa-info-circle ml-2 text-muted" />
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="nvs-version-format-tooltip">Use version format: 003.013.000</Tooltip>}
            >
              <i className="fas fa-question-circle ml-2 text-muted" />
            </OverlayTrigger>
          </Col>
          <Col xs={6}>
            <Form.Control name="version" type="text" value={config.version} disabled />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={3}>Platform</Col>
          <Col xs={6}>
            <Form.Control name="platform" type="text" value={config.platform} disabled />
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={3}>Type</Col>
          <Col xs={6}>
            {/* @ts-ignore */}
            <Form.Control
              required
              name="type"
              as="select"
              value={forceUpdateType}
              onChange={(e) => setForceUpdateType(e.target.value)}
            >
              {['optional', 'mandatory'].map((type) => (
                <option value={type} key={type}>
                  {type}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Row>
        <Modal.Footer className="px-0">
          <Button
            disabled={loading}
            onClick={() => {
              onSave(forceUpdateType);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default EditVersionConfigModal;
